import { Injectable } from '@angular/core';
import { IAdvisor } from './advisor';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IQuestions } from './questions';
import { HttpClient } from '@angular/common/http';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';


@Injectable({ providedIn: 'root' })
export class Service {
  browserLang: string;
  langSelect: string;
  private _advisors_EN: string = "../assets/advisors/advisor_en.json";
  private _advisors_FR: string = "../assets/advisors/advisor_fr.json";

  private _url_FR: string = "../assets/i18n/fr.json";
  private _url_EN: string = "../assets/i18n/en.json";
  currentLang: string;

  changeLang(lang: string) {
    this.currentLang = lang;
    if (this.currentLang === "en") {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      sessionStorage.setItem("language", "en");
      this.localize.changeLanguage('en');

    }
    else {
      this.translate.setDefaultLang('fr');
      this.translate.use('fr');
      sessionStorage.setItem("language", "fr");
      this.localize.changeLanguage('fr');
      this.localize.changeLanguage('fr'); 
      
    }
  }

  getQuestions(): Observable<IQuestions[]> {
    if (this.currentLang === "en") {
      return this.http.get<IQuestions[]>(this._url_EN);
    }
    else {
      return this.http.get<IQuestions[]>(this._url_FR);
    }
  }


  getAdvisors(): Observable<IAdvisor[]> {
    this.currentLang = sessionStorage.getItem("language")

    if (this.currentLang === "en") {
      return this.http.get<IAdvisor[]>(this._advisors_EN);
    }
    else {
      return this.http.get<IAdvisor[]>(this._advisors_FR);
    }
  }


  // the list of questions and their answers
  questions = [];

  // the ID of the current question displayed. Used to navigate and query a specific question.
  questionId: number;

  // The list of answers.
  answers = [];

  constructor(public router: Router, private http: HttpClient, public translate: TranslateService, private localize: LocalizeRouterService)
  
  {

    // if (sessionStorage.getItem('language')) {
    //   translate.setDefaultLang(sessionStorage.getItem('language'));
    //   translate.use(sessionStorage.getItem('language'));
    // } else {
    //   translate.setDefaultLang('en');
    //   translate.use('en');
    //   sessionStorage.setItem("language", "en");
    // }
    // this.changeLang(this.translate.currentLang);

    //let questiondata: { string: questionsList[] } = JSON.parse(questionsList);
  }

  /*
    4. Store the answer. Called when the user clicks on an answer.
    Because we are already checking if the question ID isn't greater than the total of questions, we don't need to check if the answer given by the user is the last one.

    Go to answer.component.html
  */
  
  validate(answer) {
    this.answers.push({ question: this.questions[this.questionId].question, answer });
  }

}

